module.exports = __webpack_public_path__ + "static/img/banner.81dd052d.png";